import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const removeEmergentArtifacts = () => {
  const badge = document.getElementById("emergent-badge");
  if (badge) {
    badge.remove();
  }

  document
    .querySelectorAll('script[src*="assets.emergent.sh/scripts/emergent-main.js"]')
    .forEach((scriptEl) => scriptEl.remove());
};

removeEmergentArtifacts();

const emergentCleanupObserver = new MutationObserver(() => {
  removeEmergentArtifacts();
});

emergentCleanupObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
